import {
  QUERY_KEYS,
  soCaiColumns,
  thanhToanPhaiTraColumns,
  theKhoColumns,
  thueVatDauRaColumns,
  thueVatDauVaoColumns
} from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

interface HoverDropdownProps {
  uuid: string;
  ma_ct?: string;
}

const tableItems: InfoTableItem[] = [
  { title: 'Xem sổ kho, mua/bán hàng', endpoint: QUERY_KEYS.SO_KHO, columns: theKhoColumns, group: 1 },
  { title: 'Xem sổ cái', endpoint: QUERY_KEYS.SO_CAI, columns: soCaiColumns, group: 1 },
  {
    title: 'Thanh toán phải trả',
    endpoint: QUERY_KEYS.THANH_TOAN_PHAI_TRA,
    columns: thanhToanPhaiTraColumns,
    group: 1
  },
  { title: 'Thuế VAT đầu ra', endpoint: QUERY_KEYS.THUE_VAT_DAU_RA, columns: thueVatDauRaColumns, group: 1 },
  { title: 'Thuế VAT đầu vào', endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO, columns: thueVatDauVaoColumns, group: 1 }
];

export const HoverDropdown = ({ uuid, ma_ct }: HoverDropdownProps) => (
  <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} />
);
